export default {
    homePage: {
        Todolist: 'To-do-list',
        New: 'New',
        Processing: 'Processing',
        Error: 'Error',
        InProcess: 'In Process',
        Draft: 'Draft',
        ApprovalPending: 'Approval Pending',
        AwaitingProcessing: 'Awaiting Processing',
        InProgress: 'In Progress',
        ApprovalRejected: 'Approval Rejected',
        QuickAccess: 'Quick Access',
        AddInbound: 'Add Inbound',
        AddProduct: 'Add Product',
        Inventory: 'Inventory',
        AddOutbound: 'Add Outbound',
        AddReturn: 'Add Return',
        AddTicket: 'Add Ticket',
        KeyData: 'Key Data',
        Date: 'Date',
        Yesterday: 'Yesterday',
        Last7Days: 'Last 7 Days',
        Last30Days: 'Last 30 Days',
        TotalOutbound: 'Total Outbound',
        ShippedOutbound: 'Shipped Outbound',
        TotalInbound: 'Total Inbound',
        ShippedInbound: 'Shipped Inbound',
        TotalReturn: 'Total Return',
        BasicStatistic: 'Basic Statistic',
        OrdersShipped: 'Orders Shipped',
        AvailableSKU: 'Available SKU',
        AvailableInventory: 'Available Inventory',
        AuthorizedStore: 'Authorized Store',
        ProcessedReturn: 'Processed Return',
        OutboundOrder: 'Outbound Order Notification',
        SalesManager: 'Sales Manager',
        CustomerService: 'Customer Service',
        TotalCustomers: 'Total Customers',
        Inbound: 'Inbound',
        Product: 'Product',
        Outbound: 'Outbound',
    },
    systemOnlineNtf: {
        title: 'Title',
        version: 'Version',
        notifyDate: 'Release Date',
        notifyStatus: 'Notification Status',
        loginName: 'Created By',
        readNumber: 'Readers',
        newAddFe: 'New Features',
        feList: 'Feature List',
        filesList: 'Attachment List',
        checkReadText: 'I have read and understood the system update',
        checkAndClose: 'Confirm and Close',
        description: 'Overview',
        featureName: 'Name',
        featureDescription: 'Description',
        preViewNtf: 'Preview Notification',
        featureImg: 'Feature Screenshot',
        opManual: 'User Guide',
        upLineConfirm: 'Confirm Go Online?',
        downLineConfirm: 'Confirm Take Offline?',
        draftConfirm: 'Confirm Save as Draft?',
        publishConfirm: 'Confirm Publish?',
        moreVersion: 'View Update History',
        ntfMenu: 'Go-Live Notification',
        ntfDialogTitle: 'ERP System Release Notes'
      }
}